import angular from 'angular';
import uiRouter from 'angular-ui-router';
import statesTemplatesComponent from './states-templates.component';
import dataTable from 'angular-material-data-table';

let statesTemplatesModule = angular
  .module('statesTemplates', [uiRouter, dataTable])

  .config($stateProvider => {
    'ngInject';
    $stateProvider.state('statesTemplates', {
      url: '/states-templates',
      component: 'statesTemplates',
      parent: 'main',
      data: {
        permissions: {
          only: ['ADMIN'],
          redirectTo: 'home'
        }
      },
      resolve: {}
    });
  })
  .component('statesTemplates', statesTemplatesComponent).name;

export default statesTemplatesModule;
